import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useUserActionsListFilterFields } from './hooks/useUserActionsListFilterFields';

export const UserActionsListFilterChips: React.FC = () => {
  const fields = useUserActionsListFilterFields();

  return <FilterChips fields={fields} />;
};
